import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showHeader: true
  },
  mutations: {
    SET_showHeader:  (state, payload) => {
      state.showHeader = payload;
    },
  },
  getters: {
    
    GET_showHeader: state => {
      return state.showHeader;
    },
  },
  actions: {}
});
